import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { CheckCircleOutlined } from '@mui/icons-material';
import TextField from './TextField';
import PicklistField from './PicklistField';
import ReferenceField from './ReferenceField';
import DateField from './DateField';
import NumberField from './NumberField';
import BooleanField from './BooleanField';
import { statusChipSx, tintSx, FONT } from '../../styles/wizardSx';

const FIELD_COMPONENTS = {
  text: TextField,
  textarea: TextField,
  email: TextField,
  phone: TextField,
  url: TextField,
  picklist: PicklistField,
  reference: ReferenceField,
  date: DateField,
  datetime: DateField,
  number: NumberField,
  currency: NumberField,
  boolean: BooleanField
};

function DynamicField({ field, value, onChange, operator, strictPicklist = false, ...props }) {
  const FieldComponent = FIELD_COMPONENTS[field.type] || TextField;

  // Operators that don't require a value
  const noValueOperators = ['is_empty', 'is_not_empty', 'is_null', 'is_not_null'];

  if (noValueOperators.includes(operator)) {
    return (
      <Box
        sx={[
          {
            height: '45px',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'outline.variant',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            px: 2
          },
          (theme) => tintSx(theme, 0.04)
        ]}
      >
        <CheckCircleOutlined sx={{ color: 'primary.main', fontSize: 18 }} />
        <Typography sx={{ fontSize: FONT.body, color: 'text.primary', fontWeight: 500 }}>
          No value required
        </Typography>
        <Chip label="Auto" size="small" sx={[{ height: '20px' }, statusChipSx('info')]} />
      </Box>
    );
  }

  return (
    <FieldComponent
      field={field}
      value={value}
      onChange={onChange}
      allowCustom={field.type === 'picklist' ? !strictPicklist : undefined}
      {...props}
    />
  );
}

export default DynamicField;
